import type { TextWidgetV2 } from "../textV2";
import type { ActiveLinkRef, ScenePoint } from "./types";
import { createCanvasRunAnchor, invertWidgetTransform, pointInRect } from "./utils";

export class CanvasLinkHoverResolver {
    hitTest(widget: TextWidgetV2, scenePoint: ScenePoint): ActiveLinkRef | null {
        const localPoint = invertWidgetTransform(widget, scenePoint);
        const lineIndex = widget.getLineIndexAtLocalY(localPoint.y);
        if (lineIndex < 0) {
            return null;
        }

        const runs = widget.getLinkRunsByLine(lineIndex);

        for (const run of runs) {
            if (pointInRect(localPoint, run.localRect)) {
                return {
                    widgetId: widget.UID,
                    url: run.url,
                    mode: "viewing",
                    lineIndex: run.lineIndex,
                    runIndex: run.runIndex,
                    anchor: createCanvasRunAnchor(run.key, widget, run.localAnchorRect),
                };
            }
        }

        return null;
    }
}
